import { Card, Inline, Skeleton, Stack } from '@cortex/ui';

export function PipelineBarSkeleton() {
  return (
    <Card className="p-5">
      <Stack gap="sm">
        <Skeleton className="h-[22px] w-[150px]" />
        <Skeleton className="h-3 w-full rounded-full" />
        <Inline gap="lg">
          {Array.from({ length: 5 }).map((_, i) => (
            <Inline key={i} gap="xs">
              <Skeleton className="h-2.5 w-2.5 rounded-full" />
              <Skeleton className="h-3 w-[60px]" />
            </Inline>
          ))}
        </Inline>
      </Stack>
    </Card>
  );
}
